module.exports = __webpack_public_path__ + "img/img11.85145368.svg";